/**
 * Async boundary for Module Federation.
 *
 * Everything this module used to do now lives in `./bootstrap`. The single
 * dynamic import defers it past the tick in which the share scope is set up,
 * which is what lets `@optiaxiom/globals` be shared without `eager: true`.
 *
 * Why that matters: `eager` compiles the fallback copy straight into the entry
 * chunk and consumes it synchronously, before any remote has registered. Lazy
 * route code then resolves the *same* package through the share scope and can
 * get a different copy — two module instances of a package whose `toaster` and
 * Axiom contexts are module-level singletons, so `toaster.create()` appended to
 * one store while the mounted viewport rendered the other. See OPAL-6310.
 *
 * With the boundary in place every consume goes through the share scope and
 * resolves to one instance. Keep this file a bare dynamic import: anything
 * added here executes before the boundary and reintroduces the problem.
 */
import('./bootstrap.tsx');

export {};
